"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden lg:flex gap-2">
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList>
          {menuItems.slice(0, 5).map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative inline-flex h-9 items-center justify-center px-4 py-2 text-sm font-medium text-white transition-colors hover:!bg-transparent focus:!bg-transparent">
                  {item.label}
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="lg:hidden text-white hover:!bg-transparent focus:!bg-transparent" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
        {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-primary border-t border-white/10 lg:hidden shadow-strong">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {menuItems.slice(0, 5).map(item => <Link key={item.id} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-white hover:bg-white/10 rounded-md transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "py-3 shadow-medium" : "py-5"}`}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between gap-8">
          {}
          <Link to="/#" className="shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515527/img/thrive_supported_living_logo.png" alt="Thrive Supported Living Services Limited" className="h-7" />
          </Link>

          {}
          <div className="flex-1 flex justify-center">
            <MenuProvider menu_id="3">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <Button asChild className="hidden lg:inline-flex bg-secondary2 text-foreground-secondary2 hover:bg-secondary2-hover hover:!bg-secondary2-hover hover:shadow-medium hover:-translate-y-0.5 focus:!bg-secondary2 focus-visible:ring-secondary2/30 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] border border-secondary2-dark shadow-soft">
            <Link to="#residents-hub">Residents Hub</Link>
          </Button>
        </div>
      </div>
    </header>;
}